/**
 * # Get Sibling After
 * Get a nearest sibling after the given element which matches
 * the given query selector.
 *
 * @param {Element} el
 * @param {String} query
 * @return {Element|Null}
 *
 */

import matches from "../dom/matches";

function getSiblingAfter(el, query) {
  // @TODO: utils/traversal methods should be rewritten to Typescript
  while ((el = el.nextElementSibling)) {
    if (matches(el, query)) {
      return el;
    }
  }

  return null;
}

export default getSiblingAfter;
